<template>
  <RouterView />
  <CfToast ref="t" />
</template>
<script setup lang="ts">
import { ref, provide } from 'vue'
import { RouterView } from 'vue-router'
import { CfToast, type ToastItem } from '@careerforge/ui'
const t = ref<InstanceType<typeof CfToast> | null>(null)
provide('toast', (x: Omit<ToastItem, 'id'>) => t.value?.add(x))
</script>
